const topics = [
  { name: '韩漫推荐', count: '12.8万', hot: true },
  { name: '霸道总裁', count: '9.6万', hot: true },
  { name: '下拉式阅读', count: '8.3万', hot: false },
  { name: '甜宠恋爱', count: '7.5万', hot: true },
  { name: '日漫全集', count: '6.9万', hot: false },
  { name: '修仙国漫', count: '6.2万', hot: true },
  { name: '悬疑反转', count: '5.4万', hot: false },
  { name: '免费漫画', count: '8.8万', hot: true },
  { name: '更新速递', count: '4.7万', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            热门话题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            话题广场
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            布丁漫画网读者最关注的热门话题标签，发现你感兴趣的漫画类型
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-default"
            >
              {topic.hot && (
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse flex-shrink-0"></span>
              )}
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {topic.count}阅读
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}